import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const NoDataAvailable: React.FC<{
  text?: string;
  bgColor?: string;
}> = ({ text, bgColor = "" }) => {
  const { t } = useTranslation();
  return (
    <Box
      data-testid="boxb"
      sx={{
        height: "100% !important",
        width: "100% !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "100%",
        maxHeight: "100%",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Box
        data-testid="box"
        className="no-data"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src={require("../assets/images/Anim-icon/no-data-anim2.webp")}
          alt=""
        ></img>
        {/* <img src={require(`../assets/images/no-data.jpg`)} alt=""></img>{" "} */}
        <br></br>
        <span>{text ?? t('common.noDataAvailable')}</span>
      </Box>
    </Box>
  );
};

export default NoDataAvailable;
